"use client";
import { ArrowsChevronRight } from "@fanduel/formation-react-icons";
import { MouseEventHandler } from "react";
import Link from "@/components/link/Link";
import {
  HEAD_TO_HEAD_MODULE_CTA_CLICKED,
  HEAD_TO_HEAD_STATUS_MAP,
} from "@/constants/amplitude";
import { NFL } from "@/constants/sports";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import ctaLinkStyles from "./CtaLink.module.scss";

type CtaLinkProps = {
  href: string;
  next: boolean;
  label: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  ampModule?: string;
};

const CtaLink = ({ href, next, label, onClick, ampModule }: CtaLinkProps) => {
  const { eventName, gameState } = useHeadToHeadContext();
  const { logAmplitudeEvent } = useAmplitude();
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    try {
      if (onClick) {
        onClick(e);
      }
    } finally {
      logAmplitudeEvent(HEAD_TO_HEAD_MODULE_CTA_CLICKED, {
        Sport: NFL,
        "Event Name": eventName,
        Module: ampModule ?? "unknown",
        "Link URL": href,
        "Link Text": label,
        "Page State": HEAD_TO_HEAD_STATUS_MAP[gameState],
      });
    }
  };
  return (
    <Link next={next} href={href} onClick={handleClick}>
      <div className={ctaLinkStyles.content}>
        <div>{label}</div>
        <ArrowsChevronRight />
      </div>
    </Link>
  );
};

export default CtaLink;
